import { useEffect, useState } from 'react';

/**
 * localStorage に開閉状態を永続化するアコーディオン state。
 *
 * GenerationWorkspace で 8 箇所コピペされていた
 * 「useState(() => localStorage.getItem(key) ...)」+「useEffect で setItem」の
 * 組を 1 本にまとめたもの (挙動不変)。
 *
 * @param storageKey localStorage のキー。'true' / 'false' の文字列で保存する
 * @param defaultOpen 保存値が無いときの初期値
 * @param options.persist false の間は保存をスキップする (= 保存済みの値を温存する)。
 *   静止画のプロンプト入力モードでは全アコーディオンを強制的に閉じるため、
 *   その閉状態を localStorage に書き戻さない用途で使う。既定 true。
 */
export function useAccordionState(
  storageKey: string,
  defaultOpen: boolean,
  options?: { persist?: boolean },
) {
  const persist = options?.persist ?? true;

  const [isOpen, setIsOpen] = useState(() => {
    const saved = localStorage.getItem(storageKey);
    return saved !== null ? saved === 'true' : defaultOpen;
  });

  useEffect(() => {
    if (persist) {
      localStorage.setItem(storageKey, String(isOpen));
    }
  }, [storageKey, isOpen, persist]);

  return [isOpen, setIsOpen] as const;
}
